<template>
  <main>
    <section class="content-wrapper">
      <ag-header
        title="Uns interessiert Ihre Meinung!"
      />
      <div class="content__body">
        <p>
          Wir wollen wissen, wie Ihnen unser neues Kundencenter gefällt.
          Dafür haben wir ein Feedback-Formular erstellt. Hier können Sie
          Kritik und Lob zu einzelnen Funktionen und zum Kundencenter als
          Ganzes hinterlassen.
        </p>
        <p>
          Auch für Anregungen und Wünsche gibt es hier Platz. Wir würden uns
          freuen, wenn Sie sich kurz Zeit nehmen, unsere Fragen zu beantworten.
        </p>
        <p>
          Das neue Kundencenter wird fortwährend weiterentwickelt. Gerne können
          Sie in dem Formular auch Anregungen für neue Funktionen und Verbesserungen
          hinterlassen.
        </p>
        <p>
          Das Formular ist anonym und ohne Anmeldung zugänglich.
        </p>
        <a
          class="button-link"
          href="https://docs.google.com/forms/d/e/1FAIpQLSfnoHNAHOv-MBOwQ0-MCmxJx19BWfRo4dpqdbWzG29w2kasdQ/viewform?usp=sf_link"
          target="_blank"
        >
          Feedback geben
        </a>
      </div>
    </section>
  </main>
</template>

<script>
import AgHeader from '@/components/shared/AgHeader.vue';

export default {
  name: 'survey',
  components: {
    AgHeader,
  },
  metaInfo: {
    title: 'Feeback',
  },
  props: {
    serviceData: {
      type: Array,
      default: null,
      required: false,
    },
    activeServices: {
      type: Array,
      default: null,
      required: false,
    },
    inactiveServices: {
      type: Array,
      default: null,
      required: false,
    },
  },
};
</script>

<style lang="scss">
</style>
